import { AdminMessage } from "@sendbird/chat/message";
import { CoreMessageType, SendableMessageType } from "@sendbird/uikit-react/types/utils";
import { MessageCustomTypes } from "../../../appV2/Chat/type";

const DEFAULT_ADMIN_MESSAGE_TYPES = [
  MessageCustomTypes.SHIFT_BOOKED,
  MessageCustomTypes.SHIFT_INVITE_RESPONSE,
];

const HIDDEN_MESSAGE_TYPES = [
  MessageCustomTypes.SHIFT_REVIEW,
  MessageCustomTypes.INPUT_ETA,
  MessageCustomTypes.INPUT_ETA_SUBMITTED,
  MessageCustomTypes.SHIFT_ACTION,
];

export function shouldRenderDefaultAdminMessage(message: CoreMessageType): message is AdminMessage {
  return (
    isAdminMessage(message) &&
    DEFAULT_ADMIN_MESSAGE_TYPES.includes(message.customType as MessageCustomTypes)
  );
}

export function isAdminMessage(message: CoreMessageType): message is AdminMessage {
  return message.messageType === "admin";
}

export function isSendableMessage(message: CoreMessageType): message is SendableMessageType {
  return message.messageType === "user" || message.messageType === "file";
}

export function hideMessage(message: CoreMessageType): boolean {
  return HIDDEN_MESSAGE_TYPES.includes(message.customType as MessageCustomTypes);
}

export function isShiftInviteRequestMessage(message: CoreMessageType): message is AdminMessage {
  return isAdminMessage(message) && message.customType === MessageCustomTypes.SHIFT_INVITE_REQUEST;
}
